var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons is-centered"},[_c('b-button',{attrs:{"tag":"router-link","to":_vm.getPath(),"type":"is-info","expanded":"","loading":_vm.loading}},[_vm._v(" "+_vm._s(_vm.startButtonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }